import { SiteInfo, UserInfo } from "@/api/type";
import { create } from "zustand";

type UserStoreState = {
  user: UserInfo | null;
  site: SiteInfo | null;
  siteDetail: any;
  permission: any;
  availableSites: any[];
  sitePaymentKeys: any[];
  isWebPurchase: boolean;
  isWebPurchaseLodge: boolean;
  isWebPurchaseTicket: boolean;
  isWebShopping: boolean;
  isManaged: boolean;
  adminInquiry: boolean;
  adminTargetSubdomain: string | null;

  setUser: (user: any) => void;
  setSite: (site: any) => void;
  setSiteDetail: (siteDetail: any) => void;
  logout: () => void;
  setPermission: (permission: any) => void;
  setAvailableSites: (availableSites: any[]) => void;
  setSitePaymentKeys: (sitePaymentKeys: any[]) => void;
  setIsWebPurchase: (isWebPurchase: boolean) => void;
  setIsWebPurchaseLodge: (isWebPurchaseLodge: boolean) => void;
  setIsWebPurchaseTicket: (isWebPurchaseTicket: boolean) => void;
  setIsWebShopping: (isWebShopping: boolean) => void;
  setIsManaged: (isManaged: boolean) => void;
  setAdminInquiry: (adminInquiry: boolean) => void;
  setAdminTargetSubdomain: (adminTargetSubdomain: string | null) => void;
};

export const useUserStore = create<UserStoreState>((set) => ({
  user: null,
  site: null,
  siteDetail: null,
  permission: null,
  availableSites: [],
  sitePaymentKeys: [],
  isWebPurchase: false,
  isWebPurchaseLodge: false,
  isWebPurchaseTicket: false,
  isWebShopping: false,
  isManaged: false,
  adminInquiry: false,
  adminTargetSubdomain: null,

  setUser: (user) => set({ user }),
  setSite: (site) => set({ site }),
  setSiteDetail: (siteDetail) => set({ siteDetail }),
  logout: () => set({ user: null }),
  setPermission: (permission) => set({ permission }),
  setAvailableSites: (availableSites) => set({ availableSites }),
  setSitePaymentKeys: (sitePaymentKeys) => set({ sitePaymentKeys }),
  setIsWebPurchase: (isWebPurchase) => set({ isWebPurchase }),
  setIsWebPurchaseLodge: (isWebPurchaseLodge) => set({ isWebPurchaseLodge }),
  setIsWebPurchaseTicket: (isWebPurchaseTicket) => set({ isWebPurchaseTicket }),
  setIsWebShopping: (isWebShopping) => set({ isWebShopping }),
  setIsManaged: (isManaged) => set({ isManaged }),
  setAdminInquiry: (adminInquiry) => set({ adminInquiry }),
  setAdminTargetSubdomain: (adminTargetSubdomain) => set({ adminTargetSubdomain }),
}));
